import React from "react";
import "./about-us.css";
import { Button, Grid, Typography } from "@mui/material";
import SectionContainer from "../../../components/landing/section-container";
import scrollToSection from "../../../helpers/scroll-to-id";
import CarouselPage from "../carousel";

function AboutUsPage() {
  return (
    <SectionContainer id="about-us" title="Acerca de Nosotros">
      <div className="about-us">
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <CarouselPage />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ alignContent: "center" }}>
            <Typography>
              ¡Nuestra residencia estudiantil moderna y segura ya está lista
              para recibirte! Ofrecemos un ambiente ideal para tus estudios y
              vida social, con habitaciones disponibles desde 145,000.
            </Typography>
            <br />
            <Typography>
              No pierdas la oportunidad de ser parte de nuestra comunidad
              estudiantil y disfrutar de un espacio cómodo y seguro para tu vida
              universitaria.
            </Typography>
            <Button
              onClick={() => scrollToSection("contact-us")}
              variant="outlined"
              sx={{ maxWidth: 200, marginTop: 5 }}
            >
              Contactar
            </Button>
          </Grid>
        </Grid>
      </div>
    </SectionContainer>
  );
}

export default AboutUsPage;
